
import * as SocialLogin from './socialLogins';
const createScript = () => {
  // load the sdk
  // window.fbAsyncInit = fbAsyncInit;
  const script = document.createElement('script');
  script.src = 'https://accounts.google.com/gsi/client';
  script.async = true;
  script.onload = initGoogleGSI;
  document.body.appendChild(script);
}

createScript();
const initGoogleGSI = () => {
  console.log('initGoogleGSI SDK initialized');
}



export const popupConsentLogin =  async () => {
  const client = window.google.accounts.oauth2.initTokenClient({
    client_id: SocialLogin.GOOGLE_CLIENT_ID,
    scope: `profile email`,
    callback: '' // defined at request time
  });
  const tokenResponse = await new Promise((resolve, reject) => {
    try {
      // Settle this promise in the response callback for requestAccessToken()
      client.callback = (resp) => {
        if (resp.error !== undefined) {
          reject(resp);
        }

        resolve(resp);
      };
      client.requestAccessToken({ prompt: 'consent' });
    } catch (err) {
      console.log(err)
    }
  });
  return tokenResponse;
}
export const SignUpUser =  async () => {
  const SCOPES = ["https://www.googleapis.com/auth/user.birthday.read",
  "https://www.googleapis.com/auth/profile.agerange.read",
  "https://www.googleapis.com/auth/userinfo.profile",
  "https://www.googleapis.com/auth/userinfo.email",
].join(" ");
  const client = window.google.accounts.oauth2.initTokenClient({
    client_id: SocialLogin.GOOGLE_CLIENT_ID,    
    scope: SCOPES,
    callback: '' // defined at request time
  });
  const tokenResponse = await new Promise((resolve, reject) => {
    try {
      // Settle this promise in the response callback for requestAccessToken()
      client.callback = (resp) => {
        if (resp.error !== undefined) {
          reject(resp);
        }

        resolve(resp);
      };
      client.requestAccessToken({ prompt: 'consent' });
    } catch (err) {
      console.log(err)
    }
  });
  return tokenResponse;
}

export const promptLogin =  async () => {
  
  const tokenResponse = await new Promise((resolve, reject) => {
    try {
      const goog=window.google.accounts.id;
  const client = goog.initialize({
    client_id: SocialLogin.GOOGLE_CLIENT_ID,
    scope: `profile email`,
    callback: handleCredentialResponse // defined at request time
  });
      // Settle this promise in the response callback for requestAccessToken()
      function handleCredentialResponse(resp){
        if (resp.error !== undefined) {
          reject(resp);
        }

        resolve(resp);
      };
      window.google.accounts.id.prompt((notification) => {
        
        if(notification.isNotDisplayed()) {

          window.google.accounts.id.prompt();
          resolve(popupConsentLogin());
        }
      });
    } catch (err) {
      console.log("promptLogin err",err)
    }
  });
  return tokenResponse;
}





// WEBPACK FOOTER //
// ./src/utils/googleOauth.js